module.exports = __webpack_public_path__ + "img/small_40 Antracyt.6527a079.png";